import { Image } from 'react-konva';
import { ImageOverlayerInner } from '@starflow/app/components/canvas/elements/image';
import { GroupOverlayerInner } from '../components/canvas/elements/group';

const elements = {};
const overlayers = {};
const configs = {};
const canvasTools = [];
const elementTools = [];
const toolbars = {};

const rootElements = {
  lower: [],
  upper: [],
};

const wrappedElements = { image: Image };
const wrappedOverlayers = { image: ImageOverlayerInner, group: GroupOverlayerInner };

export const getElements = () => {
  return elements;
};

export const getRootElements = () => {
  return rootElements;
};

export const getElementToolbar = (type) => {
  return toolbars[type];
};

export const getWrappedElement = (type, originalElement) => {
  return wrappedElements[type] || originalElement;
};

export const getWrappedOverlayer = (type, originalOverlayer) => {
  return wrappedOverlayers[type] || originalOverlayer;
};

export const getCanvasTools = () => {
  return canvasTools;
};

export const getElementTools = () => {
  return elementTools;
};

export const getOverlayers = () => {
  return overlayers;
};

export const getConfigs = () => {
  return configs;
};

export const wrapElement = (type, wrapper) => {
  const PrevElement = wrappedElements[type];
  const PrevOverlayer = wrappedOverlayers[type];

  wrapper.element && (wrappedElements[type] = wrapper.element(PrevElement));
  wrapper.overlayer && (wrappedOverlayers[type] = wrapper.overlayer(PrevOverlayer));
};

export const registerElementTool = (tool) => {
  elementTools.push(tool);
};

export const registerElement = (type, { element, overlayer, tool, toolbar, config }) => {
  elements[type] = element || elements[type];
  overlayers[type] = overlayer || overlayers[type];
  configs[type] = config || configs[type];
  toolbars[type] = toolbar || toolbars[type];

  if (tool) {
    tool.name = type;
    canvasTools.push(tool);
  }
};

export const registerRootElement = (layer, { Component, config }) => {
  rootElements[layer].push({ Component, config });
};
